import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ children }) => <div id="body">{children}</div>;

Body.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body.js